import AvatarPlaceholder from "assets/svgs/avatar.svg";

export default function EventPeople({ relatedPeople }) {
  return (
    <section className="pt-2">
      <h3 className="font-semibold mb-2">Related People</h3>
      <div className="sm:gap-4 sm:grid sm:grid-cols-2">
        {relatedPeople.map((person) => {
          const { first_name, last_name, images, relationship } = person;
          const photoUrl = images.length > 0 && images[0].url;
          return (
            <figure
              key={`${first_name}-${last_name}`}
              className="flex mt-4 sm:mt-0"
            >
              {photoUrl ? (
                <div
                  className="rounded-50pc h-8 w-8"
                  style={{
                    backgroundImage: `url(${photoUrl})`,
                    backgroundPosition: "center center",
                    backgroundSize: "cover",
                  }}
                ></div>
              ) : (
                <AvatarPlaceholder className="block h-8 w-8" />
              )}
              <figcaption className="px-2">
                <strong className="block text-sm font-semibold leading-snug">
                  {first_name && first_name} {last_name && last_name}
                </strong>
                <p className="capitalize text-gray-500 text-xs">
                  {relationship && relationship}
                </p>
              </figcaption>
            </figure>
          );
        })}
      </div>
    </section>
  );
}
